/**
 * Report Upload Demo Page
 * Demonstrates the report upload API functionality
 */

import React from 'react';
import { ReportUploadForm } from '@/components/ReportUploadForm';

export default function ReportUploadDemo() {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Demo API Upload Báo Cáo
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Trang demo cho Edge Function API upload file báo cáo lên Supabase Storage. 
            API này có thể được gọi từ các ứng dụng khác để upload và lưu trữ báo cáo.
          </p>
        </div>

        <ReportUploadForm />

        {/* API Documentation */}
        <div className="mt-12 max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm border p-6">
            <h2 className="text-2xl font-semibold mb-4">API Documentation</h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-medium mb-2">Endpoint</h3>
                <code className="bg-gray-100 px-3 py-1 rounded text-sm">
                  POST https://zomlivqodrcwfazergfa.supabase.co/functions/v1/upload-report
                </code>
              </div>

              <div>
                <h3 className="text-lg font-medium mb-2">Headers</h3>
                <pre className="bg-gray-100 p-3 rounded text-sm overflow-x-auto">
{`Content-Type: application/json
Authorization: Bearer YOUR_SUPABASE_ANON_KEY`}
                </pre>
              </div>

              <div>
                <h3 className="text-lg font-medium mb-2">Request Body</h3>
                <pre className="bg-gray-100 p-3 rounded text-sm overflow-x-auto">
{`{
  "legacy_id": "string (required)",
  "id_group": "string (optional)",
  "period": "string (optional)",
  "report_date": "string (optional)",
  "id_team": "string (optional)", 
  "report_name": "string (optional)",
  "summary": "string (optional)",
  "created_by_user_id": "string (optional)",
  "bod_comment": "string (optional)",
  "file_name": "string (required)",
  "file_data": "string (required, base64 encoded)",
  "file_type": "string (optional, MIME type)"
}`}
                </pre>
              </div>

              <div>
                <h3 className="text-lg font-medium mb-2">Response</h3>
                <pre className="bg-gray-100 p-3 rounded text-sm overflow-x-auto">
{`{
  "success": true,
  "message": "Report uploaded and saved successfully",
  "data": {
    "report_id": "uuid",
    "file_path": "reports/2025/filename.pdf",
    "file_url": "https://...supabase.co/storage/v1/object/public/report-files/..."
  }
}`}
                </pre>
              </div>

              <div>
                <h3 className="text-lg font-medium mb-2">Curl Example</h3>
                <pre className="bg-gray-100 p-3 rounded text-sm overflow-x-auto">
{`curl -X POST \\
  https://zomlivqodrcwfazergfa.supabase.co/functions/v1/upload-report \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer YOUR_SUPABASE_ANON_KEY" \\
  -d '{
    "legacy_id": "RPT001",
    "report_name": "Monthly Report",
    "period": "W2501",
    "file_name": "report.pdf",
    "file_data": "data:application/pdf;base64,JVBERi0xLjQ..."
  }'`}
                </pre>
              </div>

              <div>
                <h3 className="text-lg font-medium mb-2">Features</h3>
                <ul className="list-disc list-inside space-y-1 text-sm text-gray-600">
                  <li>Upload file vào Supabase Storage bucket 'report-files'</li>
                  <li>Tự động tạo đường dẫn file theo năm: reports/YYYY/filename</li>
                  <li>Lưu thông tin báo cáo vào bảng 'reports' với supabase_file_path</li>
                  <li>Hỗ trợ upsert dựa trên legacy_id</li>
                  <li>Trả về public URL để truy cập file</li>
                  <li>Tự động cleanup file nếu database operation thất bại</li>
                  <li>CORS support cho cross-origin requests</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}




